import { Oval } from 'react-loader-spinner'
import tailwind from '../../../tailwind.config.js'

export default function Spinner({ color = "fpx-red", height = "40", width = "80", strokeWidth = 5 }) {
  return (
    <div className='flex justify-center items-center'>
      <Oval
        height={height}
        width={width}
        color={tailwind.theme.colors[color]}
        secondaryColor={tailwind.theme.colors[color]}
        strokeWidth={strokeWidth}
        strokeWidthSecondary={5}
      />
    </div>
  )
}